import { DecimalPipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormatMediumDatePipe } from '@date/format-medium-date.pipe';
import { FormatTimePipe } from '@date/format-time.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TaskService } from '@geracaoz/task/task.service';
import { TranslateDirective } from '@language/translate.directive';
import { FoodMethod } from '@model/enumerations/food-method.model';
import { FoodType } from '@model/enumerations/food-type.model';
import { TransportMethod } from '@model/enumerations/transport-method.model';
import { ITask } from '@model/geracaoz/task.model';
import { IScheduleDay } from '@model/shared/schedule-day.model';
import { ISchedule } from '@model/shared/schedule.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SchedulerService } from '@util/scheduler.service';
import dayjs from 'dayjs';
import { OrderModule } from 'ngx-order-pipe';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'flw-geracaoz-candidature-frontend-task-modal',
  templateUrl: './geracaoz-candidature-frontend-task.component.html',
  imports: [
    TooltipModule,
    OrderModule,
    FormatMediumDatePipe,
    NgClass,
    DecimalPipe,
    FontAwesomeModule,
    FormatTimePipe,
    TranslateDirective,
    NgIf,
    NgForOf,
  ],
  standalone: true,
})
export class GeracaozCandidatureFrontendTaskComponent implements OnInit {
  @Input() taskId?: number;
  task?: ITask;
  TransportMethod = TransportMethod;
  FoodMethod = FoodMethod;
  FoodType = FoodType;
  activeId = 1;
  days = [
    { id: 0, name: 'Domingo' },
    { id: 1, name: 'Segunda' },
    { id: 2, name: 'Terça' },
    { id: 3, name: 'Quarta' },
    { id: 4, name: 'Quinta' },
    { id: 5, name: 'Sexta' },
    { id: 6, name: 'Sábado' },
  ];

  constructor(public modal: NgbActiveModal, public taskService: TaskService, public schedulerService: SchedulerService) {}

  clear(): void {
    this.modal.dismiss();
  }

  confirm(): void {
    this.modal.close(true);
  }

  ngOnInit(): void {
    if (this.taskId) {
      this.taskService.find(this.taskId).subscribe(res => (this.task = res.body || undefined));
    }
  }

  getTotalDays(schedule?: ISchedule): number {
    if (schedule) {
      return this.schedulerService.getTotalDays(schedule);
    }
    return 0;
  }

  getTotalHours(schedule?: ISchedule): number {
    if (schedule) {
      return this.schedulerService.getTotalHours(schedule);
    }
    return 0;
  }

  getTotalDaysPerPeriod(day?: IScheduleDay): number {
    if (day) {
      return this.schedulerService.getTotalDaysPerPeriod(day);
    }
    return 0;
  }

  getTotalHoursPerPeriod(day?: IScheduleDay): number {
    if (day) {
      return this.schedulerService.getTotalHoursPerPeriod(day);
    }
    return 0;
  }

  getHoursPerDay(day?: IScheduleDay): number {
    if (day) {
      return this.schedulerService.getHoursPerDay(day);
    }
    return 0;
  }

  getStartDate(schedule?: ISchedule): dayjs.Dayjs | undefined {
    if (schedule) {
      return this.schedulerService.getStartDate(schedule);
    }
    return undefined;
  }

  getEndDate(schedule?: ISchedule): dayjs.Dayjs | undefined {
    if (schedule) {
      return this.schedulerService.getEndDate(schedule);
    }
    return undefined;
  }

  hasDays(): boolean | undefined {
    return this.task && this.task.schedule && this.task.schedule.days && this.task.schedule.days.length > 0;
  }

  getDays(): IScheduleDay[] {
    return this.task?.schedule?.days || [];
  }
}
